// extracted by mini-css-extract-plugin
export var activeFilterButton = "_s9-c";
export var backButton = "_s9-4";
export var backIcon = "_s9-5";
export var chevronShortcut = "_s9-6";
export var container = "_s9-1";
export var editor = "_s9-8";
export var editorWrapper = "_s9-7";
export var prefix = "_s9-2";
export var searchIcon = "_s9-3";
export var suffix = "_s9-9";
export var suffixContent = "_s9-a";
export var suffixText = "_s9-b";
export var wrapper = "_s9-0";